import Page from './page/allPage'
import Nav from './nav/nav'

export default {
  Nav: Nav.zh,
  Page: Page.i18n.zh
}